export default __webpack_public_path__ + "static/media/planet4.73de6971.png";